import { cashFlowGetters } from './routines'

export default {
  [cashFlowGetters.CASH_FLOW_DETAILS]: state => state.cashFlowDetails,
  [cashFlowGetters.CASH_FLOW_DETAILS_ERROR]: state => state.cashFlowDetailsError,
  [cashFlowGetters.CASH_FLOW_FORECAST]: state => state.cashFlowForecast
}
